import styled, { keyframes } from 'styled-components';
import { theme } from '../../../styles/theme';

const riseIn = keyframes`
   from { opacity: 0; transform: translateY(-8px) scale(0.97); }
   to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const TriggerDropdown = styled.div`
   position: fixed;
   z-index: 2147482000;
   width: 320px;
   max-height: min(460px, calc(100vh - 24px));
   display: flex;
   flex-direction: column;
   background: rgba(251, 250, 254, 0.98);
   border: 1px solid ${theme.colors.border};
   border-radius: 18px;
   box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.7) inset,
      0 24px 56px -18px rgba(29, 20, 70, 0.4);
   overflow: hidden;
   animation: ${riseIn} 0.2s cubic-bezier(0.2, 0.9, 0.25, 1);
   backdrop-filter: blur(14px);

   .head {
      padding: 16px 16px 12px;
      border-bottom: 1px solid ${theme.colors.border};
      background: linear-gradient(180deg, rgba(237, 235, 250, 0.85), rgba(251, 250, 254, 0.2));
      flex-shrink: 0;

      .head-top {
         display: flex;
         align-items: center;
         justify-content: space-between;
         gap: 10px;
         margin-bottom: 6px;
      }

      .eyebrow {
         font-family: 'IBM Plex Mono', ui-monospace, monospace;
         font-size: 10.5px;
         font-weight: 650;
         letter-spacing: 0.08em;
         text-transform: uppercase;
         color: ${theme.colors.primary};
      }

      .count {
         min-width: 22px;
         height: 22px;
         padding: 0 7px;
         border-radius: 999px;
         display: inline-flex;
         align-items: center;
         justify-content: center;
         font-size: 11px;
         font-weight: 700;
         color: ${theme.colors.primary};
         background: rgba(79, 63, 224, 0.1);
         border: 1px solid rgba(79, 63, 224, 0.16);
      }

      p {
         margin: 0;
         font-size: 12.5px;
         line-height: 1.45;
         color: ${theme.colors.textSecondary};
      }
   }

   .run-all {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 12px 12px 0;
      padding: 12px 14px;
      border: 1px solid rgba(63, 203, 140, 0.4);
      border-radius: 14px;
      background:
         linear-gradient(145deg, rgba(236, 253, 245, 0.98), rgba(251, 250, 254, 0.55));
      box-shadow: 0 8px 18px -14px rgba(21, 128, 61, 0.45);
      cursor: pointer;
      transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease;
      flex-shrink: 0;

      .ic {
         width: 34px;
         height: 34px;
         border-radius: 11px;
         display: grid;
         place-items: center;
         background: linear-gradient(150deg, rgba(63, 203, 140, 0.28), rgba(63, 203, 140, 0.12));
         color: #15803d;
         flex-shrink: 0;
      }

      .copy {
         min-width: 0;
         flex: 1;
         text-align: left;

         strong {
            display: block;
            font-size: 14px;
            font-weight: 750;
            color: ${theme.colors.text};
            letter-spacing: -0.01em;
         }
         span {
            display: block;
            font-size: 11.5px;
            color: ${theme.colors.textSecondary};
            margin-top: 2px;
         }
      }

      .go {
         font-size: 12px;
         font-weight: 700;
         color: #15803d;
         opacity: 0.55;
         flex-shrink: 0;
      }

      &:hover {
         background: #fff;
         border-color: rgba(63, 203, 140, 0.65);
         transform: translateY(-1px);
         box-shadow: 0 12px 24px -14px rgba(21, 128, 61, 0.5);

         .go { opacity: 1; }
      }

      &:active {
         transform: translateY(0);
      }
   }

   .divider {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 16px 6px;
      flex-shrink: 0;

      &::before,
      &::after {
         content: '';
         flex: 1;
         height: 1px;
         background: ${theme.colors.border};
      }

      span {
         font-family: 'IBM Plex Mono', ui-monospace, monospace;
         font-size: 10px;
         font-weight: 600;
         letter-spacing: 0.06em;
         text-transform: uppercase;
         color: ${theme.colors.textTertiary};
         white-space: nowrap;
      }
   }

   .list {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 4px 10px 12px;
      display: flex;
      flex-direction: column;
      gap: 4px;

      scrollbar-width: thin;
      scrollbar-color: rgba(107, 101, 132, 0.3) transparent;

      &::-webkit-scrollbar { width: 6px; }
      &::-webkit-scrollbar-thumb {
         background: rgba(107, 101, 132, 0.28);
         border-radius: 999px;
      }
   }

   .item {
      display: flex;
      align-items: center;
      gap: 11px;
      width: 100%;
      padding: 11px 12px;
      border: 1px solid transparent;
      border-radius: 13px;
      background: transparent;
      cursor: pointer;
      text-align: left;
      transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease;

      .ic {
         width: 32px;
         height: 32px;
         border-radius: 10px;
         display: grid;
         place-items: center;
         background: rgba(79, 63, 224, 0.1);
         color: ${theme.colors.primary};
         flex-shrink: 0;
      }

      .copy {
         min-width: 0;
         flex: 1;

         strong {
            display: block;
            font-size: 13.5px;
            font-weight: 700;
            color: ${theme.colors.text};
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
         }
         span {
            display: block;
            font-size: 10.5px;
            font-family: 'IBM Plex Mono', ui-monospace, monospace;
            color: ${theme.colors.textTertiary};
            margin-top: 2px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
         }
      }

      .play {
         width: 26px;
         height: 26px;
         border-radius: 8px;
         display: grid;
         place-items: center;
         color: ${theme.colors.textTertiary};
         background: transparent;
         flex-shrink: 0;
         opacity: 0;
         transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;

         i.ti { font-size: 12px; }
      }

      &:hover {
         background: #fff;
         border-color: ${theme.colors.border};
         box-shadow: 0 8px 18px -14px rgba(29, 20, 70, 0.28);
         transform: translateY(-1px);

         .ic {
            background: ${theme.gradients.primary};
            color: #fff;
         }
         .play {
            opacity: 1;
            background: rgba(79, 63, 224, 0.1);
            color: ${theme.colors.primary};
         }
      }

      &:active {
         transform: translateY(0);
      }
   }
`;
